import {
  ButtonModule,
  GridModule,
  MarketoFormModule as MktoFormModule,
  CtaModule,
  SpacingModule,
  TitleModule,
  PanelModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { MarketoFormComponent } from './marketo-form.component';
import { TranslateModule } from '@shared/translate/translate.module';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [MarketoFormComponent],
  imports: [
    BrSdkModule,
    CommonModule,
    MktoFormModule,
    GridModule,
    TitleModule,
    ButtonModule,
    SpacingModule,
    TranslateModule,
    PipesModule,
    CtaModule,
    PanelModule,
  ],
  exports: [MarketoFormComponent],
  entryComponents: [MarketoFormComponent],
})

/**
 * Marketo Form Module
 */
export class MarketoFormModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Marketo Form': MarketoFormComponent,
    };
  }
}
